import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCssCallToAction,
  BackendMutationCreateCssCallToActionArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_CSS_CTA } from './schema';

const MUTATION = gql`
  mutation CreateCssCallToAction($campaignId: ID!, $cssSelector: String!) {
    createCssCallToAction(campaignId: $campaignId, cssSelector: $cssSelector) {
      ...CssCallToAction
    }
  }
  ${FRAGMENT_CO_CSS_CTA}
`;

type Variables = BackendMutationCreateCssCallToActionArgs;
type Result = BackendCssCallToAction;

export const createCssCTA = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
